import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'htmlExtract',
  version: '1.2.0',
  properties: [
    {
      key: 'sourceField',
      label: 'Source Field',
      type: 'string',
      required: true,
      placeholder: '{{ $node["NodeName"].html }}',
      description: 'The field containing HTML content to extract from. Supports variable interpolation.',
    },
    {
      key: 'extractionMode',
      label: 'Extraction Mode',
      type: 'options',
      required: true,
      default: 'cssSelector',
      options: [
        { value: 'cssSelector', name: 'CSS Selector' },
        { value: 'xpath', name: 'XPath' },
      ],
      description: 'The method to use for extracting data from HTML',
    },
    {
      key: 'extractions',
      label: 'Extractions',
      type: 'fixedCollection',
      required: true,
      typeOptions: {
        multipleValues: true,
      },
      description: 'Define what data to extract from the HTML',
      default: { values: [] },
      fixedCollectionOptions: [
        {
          name: 'values',
          displayName: 'Extraction',
          values: [
            {
              key: 'key',
              label: 'Key',
              type: 'string',
              required: true,
              default: '',
              placeholder: 'title',
              description: 'The key under which the extracted data will be stored',
            },
            {
              key: 'selector',
              label: 'CSS Selector',
              type: 'string',
              required: true,
              default: '',
              placeholder: 'h1.title, .article-content, #main p',
              description: 'CSS selector to locate element(s) in the HTML',
              displayOptions: {
                show: {
                  '/extractionMode': ['cssSelector'],
                },
              },
            },
            {
              key: 'xpath',
              label: 'XPath',
              type: 'string',
              required: true,
              default: '',
              placeholder: '//h1[@class="title"]/text()',
              description: 'XPath expression to locate element(s) in the HTML',
              displayOptions: {
                show: {
                  '/extractionMode': ['xpath'],
                },
              },
            },
            {
              key: 'returnValue',
              label: 'Return Value',
              type: 'options',
              required: true,
              default: 'text',
              options: [
                { value: 'text', name: 'Text Content' },
                { value: 'html', name: 'Inner HTML' },
                { value: 'attribute', name: 'Attribute Value' },
              ],
              description: 'What value to extract from the matched element(s)',
            },
            {
              key: 'attribute',
              label: 'Attribute Name',
              type: 'string',
              required: true,
              default: 'href',
              placeholder: 'href, src, data-id',
              description: 'The name of the attribute to extract',
              displayOptions: {
                show: {
                  returnValue: ['attribute'],
                },
              },
            },
            {
              key: 'returnArray',
              label: 'Return Array',
              type: 'boolean',
              required: false,
              default: false,
              description: 'Return all matching elements as an array instead of just the first match',
            },
          ],
        },
      ],
    },
    {
      key: 'options',
      label: 'Options',
      type: 'collection',
      default: {},
      description: 'Additional extraction options',
      values: [
        {
          key: 'trimWhitespace',
          label: 'Trim Whitespace',
          type: 'boolean',
          default: true,
          description: 'Remove leading and trailing whitespace from extracted text',
        },
        {
          key: 'convertEntities',
          label: 'Decode HTML Entities',
          type: 'boolean',
          default: true,
          description: 'Convert HTML entities (like &amp;) to their characters',
        },
      ],
    },
  ],
};

export default schema;
